export default [
  {
    path: "/mechanic-hours/list",
    component: () => import("@/modules/mechanic-hours/MechanicHours.vue"),
    children: [
      {
        path: "",
        name: "mechanic-hours",
        component: () =>
          import("@/modules/mechanic-hours/pages/MechanicHours.vue"),
        meta: { permissions: ["mechanic-hours-show"] }
      }
    ]
  }
];
